export class HeadwayError extends Error {
    userMessage: string;

    constructor(message: string) {
        super(message);
        this.userMessage = message;
        this.name = 'HeadwayError';
    }
}
